import { forwardRef, type HTMLAttributes, type PropsWithChildren } from 'react';
import cn from 'classnames';

import { StringXSmall } from '@/components/Typography/Typography';

import css from './styles.module.scss';

interface NavigateItemProps
  extends HTMLAttributes<HTMLDivElement>,
    PropsWithChildren {
  parentClassName?: string;
  label: string;
}

const NavigateItem = forwardRef<HTMLDivElement, NavigateItemProps>(
  ({ children, parentClassName, label, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(css.navigateItem, props.className)}
      >
        <div
          className={cn(
            'size-[48px] relative rounded-full border-white/20 border bg-main-bg',
            parentClassName,
          )}
        >
          {children}
        </div>
        <div className={css.navLabel}>
          <StringXSmall weight="bold">{label}</StringXSmall>
        </div>
      </div>
    );
  },
);

export { NavigateItem };
